export const resourceBase = 'https://staticfiles.00e.com/20dfee3ff831b194e4d20c7202CB962AC59075B964B071ff831b194e44B70/'


export const defaultStyleTp = '1';
export const channelStyleTp = '2'
export const redStyleTp = '3'

// 垃圾分类首页
export const LJStyleTp = '4'


export const ALARM_CODE = {
  FIRE_119: "0",
  FIRE_DRILL: "1",
  SMOKE_DETECTOR: "2",
  WECHAT: "3",
  HAZARD_REPORT: "4",
  MANUAL_ALARM: "5",
  EBIKE_INDOOR: "6",
  FIRE_LANE: "7",
  HIGH_ALTITUDE_FIRE: "8",
  CORRIDOR_CLUTTER: "9",
  FIRE_DOOR: "10",
  FIRE_INSPECTION: "11",
  WATER_PRESSURE: "12",
  KITCHEN_ABSENCE: "13",
  CONTROL_ROOM_ABSENCE: "14",
  BATTERY_INDOOR: "15",
  ELEVATOR: "16",
  EBIKE_CONTROL: "17",
  UV_DETECTION: "18",
  VOICE_CALL: "19",
  CALL_ALARM: "20",
  EBIKE_WARNING: "21",
  VIDEO_PATROL: "22",
  PASSAGE_MONITOR: "23",
  FIRE_EYE_CALL: "25",
  ELECTRICAL_HAZARD: "26",
  TEMP_SENSOR: "27",
  GARBAGE_DETECTION: "33",
  INDOOR_CHARGING: "34",
  CHARGING_BOX: "35",
  WATER_ACCUMULATION: "36",
  EBIKE_SHELTER: "37",
  FIRE_EXTINGUISHER: "38",
  UNATTENDED_FIRE: "39",
  // 疏散警报
  ESCAPE_ALARM: "40",
  // 室外水源
  WATER_SOURCE: "41",
  // 应急物资
  EMERGENCY_SUPPLIES: "42",
  // 消防巡查
  FIRE_PATROL: "43",
  // 应急预案
  EMERGENCY_PLAN: "44",
  // 重点人
  PERSON_OF_IMPORTANCE: "45",
  // 人员巡查
  PERSON_PATROL: "46",
  // 数据分析
  DATA_ANALYSIS: "47",
  // 决策分析
  DECISION_ANALYSIS: "48",
  // 落地垃圾
  HU_TOU_GARBAGE: "49",
  // 风险地图
  RISK_MAP: "50",
  // 感温线缆
  THERMAL_CABLE: "51",
  // 单车治理
  EBIKE_GARBAGE: "52",
};

// 电气火灾报警诱因映射
export const HIDDEN_DANGER_ISSUE_MAP = {
  1: '线径偏小',
  2: '接头松动',
  3: '线缆老化',
  4: '超负荷运行',
  5: '散热不良',
  6: '铜铝直接对接',
  7: '供电线路过长',
  8: '变压器过载',
  9: '零线虚接断路',
  10: '大功率电器同回路共用',
  11: '三相负荷不平衡',
  12: '电压调节故障',
  13: '无功过补偿',
  14: '高压串入低压回路',
  15: '线路绝缘破损',
  16: '线缆受潮进水',
  17: '零地线混接',
  18: '设备绝缘老化',
  19: '私增用电设备',
  20: '电机堵转',
};

// 积水监测 - 安装场景
export const WATERLOGGING_TYPE = [
  { value: '1', label: '道路' },
  { value: '2', label: '院落' },
];

export const WATERLOGGING_TYPE_MAP = {
  '1': '道路',
  '2': '院落',
};

// 感温线缆 - 安装场景
export const THERMAL_CABLE_TYPE = [
  { value: '1', label: '电动车棚' },
  { value: '2', label: '大屋脊' },
];

export const THERMAL_CABLE_TYPE_MAP = {
  '1': '电动车棚',
  '2': '大屋脊',
};

export const CODE_TO_TEXT_MAPPING = {
  [ALARM_CODE.FIRE_119]: "119、",
  [ALARM_CODE.FIRE_DRILL]: "消防拉动、",
  [ALARM_CODE.SMOKE_DETECTOR]: "烟感、",
  [ALARM_CODE.WECHAT]: "微信、",
  [ALARM_CODE.HAZARD_REPORT]: "隐患举报、",
  [ALARM_CODE.MANUAL_ALARM]: "手报报警、",
  [ALARM_CODE.EBIKE_INDOOR]: "电动车进楼、",
  [ALARM_CODE.FIRE_LANE]: "消防车道、",
  [ALARM_CODE.HIGH_ALTITUDE_FIRE]: "高空火眼、",
  [ALARM_CODE.CORRIDOR_CLUTTER]: "楼道堆物、",
  [ALARM_CODE.FIRE_DOOR]: "防火门、",
  [ALARM_CODE.FIRE_INSPECTION]: "防火巡查、",
  [ALARM_CODE.WATER_PRESSURE]: "消防水压、",
  [ALARM_CODE.KITCHEN_ABSENCE]: "后厨离岗、",
  [ALARM_CODE.CONTROL_ROOM_ABSENCE]: "中控离岗、",
  [ALARM_CODE.BATTERY_INDOOR]: "电瓶进楼、",
  [ALARM_CODE.ELEVATOR]: "电梯、",
  [ALARM_CODE.EBIKE_CONTROL]: "电动车管控、",
  [ALARM_CODE.UV_DETECTION]: "紫外、",
  [ALARM_CODE.VOICE_CALL]: "语音呼叫、",
  [ALARM_CODE.CALL_ALARM]: "呼叫报警、",
  [ALARM_CODE.EBIKE_WARNING]: "电动车违规预警、",
  [ALARM_CODE.VIDEO_PATROL]: "视频巡控、",
  [ALARM_CODE.PASSAGE_MONITOR]: "通道监管、",
  [ALARM_CODE.FIRE_EYE_CALL]: "呼叫火眼、",
  [ALARM_CODE.ELECTRICAL_HAZARD]: "电气隐患、",
  [ALARM_CODE.TEMP_SENSOR]: "温感、",
  [ALARM_CODE.GARBAGE_DETECTION]: "垃圾识别、",
  [ALARM_CODE.INDOOR_CHARGING]: "入户充电、",
  [ALARM_CODE.CHARGING_BOX]: "充电盒、",
  [ALARM_CODE.WATER_ACCUMULATION]: "积水监测、",
  [ALARM_CODE.EBIKE_SHELTER]: "电动车棚、",
  [ALARM_CODE.FIRE_EXTINGUISHER]: "灭火器、",
  [ALARM_CODE.UNATTENDED_FIRE]: "动火离人、",
  [ALARM_CODE.ESCAPE_ALARM]: "疏散报警、",
  [ALARM_CODE.WATER_SOURCE]: "室外水源、",
  [ALARM_CODE.EMERGENCY_SUPPLIES]: "应急物资、",
  [ALARM_CODE.FIRE_PATROL]: "消防巡查、",
  [ALARM_CODE.EMERGENCY_PLAN]: "应急预案、",
  [ALARM_CODE.PERSON_OF_IMPORTANCE]: "重点人、",
  [ALARM_CODE.PERSON_PATROL]: "人员巡查、",
  [ALARM_CODE.DATA_ANALYSIS]: "问题分析、",
  [ALARM_CODE.DECISION_ANALYSIS]: "决策分析、",
  [ALARM_CODE.HU_TOU_GARBAGE]: "落地垃圾、",
  [ALARM_CODE.RISK_MAP]: "风险地图、",
  [ALARM_CODE.THERMAL_CABLE]: "感温线缆、",
  [ALARM_CODE.EBIKE_GARBAGE]: "单车治理、",
};



// WEBPACK FOOTER //
// ./src/js/constants.js